import Radium from "radium";
import React from "react";

import { IDevice } from "@common/models";
import { random } from "@common";
import DeviceListItem from "./device-list-item";
import { deviceListStyles as styles } from "./device.styles";

export interface IDeviceListProps {
  removeDevice: (device: IDevice) => void;
  devices: IDevice[];
}

const lastListItem = {
  ...styles.listItem,
  justifyContent: "flex-end",
  width: "20%",
  flex: "1"
};

const DeviceList = (props: IDeviceListProps) => (
  <div style={styles.contentContainer as any}>
    <div>
      <div style={styles.headerRow as any}>
        <div style={styles.listItem as any}>Enhetsnavn</div>
        <div style={styles.listItem as any}>Enhets-ID</div>
        <div style={styles.listItem as any}>Godkjent?</div>
        <div style={lastListItem as any} />
      </div>
      {props.devices && props.devices.length > 0 ? (
        props.devices.map(item => {
          const uniqueKey = random();
          return (
            <DeviceListItem
              key={uniqueKey}
              device={item}
              removeDevice={props.removeDevice}
            />
          );
        })
      ) : (
        <div style={styles.noData as any} className="noData">
          Ingen enheter
        </div>
      )}
    </div>
  </div>
);

export default Radium(DeviceList);
